import React from 'react';

const ICON_STATES = {
    ERROR: 'error',
    SUCCESS: 'success',
    WARNING: 'warning',
    DISABLED: 'disabled'
};

const ICON_STATES_COLORS = {
    [ICON_STATES.ERROR]: '#f44336',
    [ICON_STATES.SUCCESS]: '#4caf50',
    [ICON_STATES.WARNING]: '#ff9800',
    [ICON_STATES.DISABLED]: '#909090'
};

const iconWrapper = (iconFace, iconFamily = 'solid') => {
    const IconComponent = React.forwardRef((props, ref) => {
        const outerStyles = props.style || {};
        const outerClassNames = props.className || '';

        return (
            <i
                {...props}
                ref={ref}
                style={{
                    ...outerStyles,
                    color: ICON_STATES_COLORS[props.color] || props.color,
                    display: 'flex'
                }}
                className={`${outerClassNames} fa-${iconFamily} ${iconFace}`}
            />
        );
    });

    return IconComponent;
};

export const ChevronLeftIcon = iconWrapper('fa-chevron-left');

export const ChevronRightIcon = iconWrapper('fa-chevron-right');

export const ChevronUpIcon = iconWrapper('fa-chevron-up');

export const ChevronDownIcon = iconWrapper('fa-chevron-down');

export const DeleteIcon = iconWrapper('fa-trash');

export const EditIcon = iconWrapper('fa-pen');

export const DuplicateIcon = iconWrapper('fa-clone');

export const ActivityInfoIcon = iconWrapper('fa-info');

export const BookingInformationIcon = iconWrapper('fa-list');

export const BookmarkIcon = iconWrapper('fa-bookmark');

export const FireIcon = iconWrapper('fa-fire');

export const BoldIcon = iconWrapper('fa-bold');

export const ItalicIcon = iconWrapper('fa-italic');

export const UnderlineIcon = iconWrapper('fa-underline');

export const UnorderedListIcon = iconWrapper('fa-list-ul');

export const OrderedListIcon = iconWrapper('fa-list-ol');

export const LinkIcon = iconWrapper('fa-link');

export const LinkSlashIcon = iconWrapper('fa-link-slash');

export const AgentNotesIcon = iconWrapper('fa-notebook', 'regular');

export const HelpIcon = iconWrapper('fa-question');

export const AgentCommissionIcon = iconWrapper('fa-chart-pie-simple', 'regular');

export const CompareIcon = iconWrapper('fa-scale-balanced');

export const CompareRightIcon = iconWrapper('fa-scale-unbalanced-flip');

export const CheckIcon = iconWrapper('fa-check');

export const TimesIcon = iconWrapper('fa-xmark');

export const EyeIcon = iconWrapper('fa-eye');

export const EyeSlashIcon = iconWrapper('fa-eye-slash');

export const RotateLeftIcon = iconWrapper('fa-rotate-left');

export const PlusIcon = iconWrapper('fa-plus');

export const MinusIcon = iconWrapper('fa-minus');

export const CartIcon = iconWrapper('fa-cart-shopping');

export const FileDownloadIcon = iconWrapper('fa-file-arrow-down');

export const LocationIcon = iconWrapper('fa-location-dot', 'regular');

export const CalendarDayIcon = iconWrapper('fa-calendar-day', 'regular');

export const ClockIcon = iconWrapper('fa-clock', 'regular');

export const TicketIcon = iconWrapper('fa-ticket-simple', 'regular');

export const UserGroupIcon = iconWrapper('fa-user-group', 'regular');

export const PhoneIcon = iconWrapper('fa-phone', 'regular');

export const EnvelopeIcon = iconWrapper('fa-envelope', 'regular');

export const NoteIcon = iconWrapper('fa-note', 'regular');

export const SearchIcon = iconWrapper('fa-magnifying-glass');

export const FilterCalendarDayIcon = iconWrapper('fa-calendar-day');

export const CalendarRangeIcon = iconWrapper('fa-calendar-days');

export const UserIcon = iconWrapper('fa-user');

export const UsersIcon = iconWrapper('fa-user-group');

export const ManifestIcon = iconWrapper('fa-users');

export const FilterIcon = iconWrapper('fa-filter');

export const ArrowUpIcon = iconWrapper('fa-arrow-up');

export const ArrowDownIcon = iconWrapper('fa-arrow-down');

export const ArrowLeftIcon = iconWrapper('fa-arrow-left');

export const ArrowRightIcon = iconWrapper('fa-arrow-right');

export const WarningIcon = iconWrapper('fa-triangle-exclamation', 'regular');

export const ChartColumnIcon = iconWrapper('fa-chart-column');

export const ErrorIcon = iconWrapper('fa-circle-exclamation', 'regular');

export const VisaIcon = iconWrapper('fa-cc-visa', 'brands');

export const MastercardIcon = iconWrapper('fa-cc-mastercard', 'brands');

export const AmexIcon = iconWrapper('fa-cc-amex', 'brands');

export const DiscoverIcon = iconWrapper('fa-cc-discover', 'brands');

export const DollarIcon = iconWrapper('fa-dollar-sign');

export const SaveIcon = iconWrapper('fa-floppy-disk');

export const OnhouseIcon = iconWrapper('fa-house', 'regular');

export const TerminalIcon = iconWrapper('fa-calculator', 'regular');

export const CashIcon = iconWrapper('fa-money-bill', 'regular');

export const HoldIcon = iconWrapper('fa-credit-card', 'regular');

export const CardIcon = iconWrapper('fa-credit-card', 'regular');

export const GiftCardIcon = iconWrapper('fa-gift-card', 'regular');

export const SummaryUpIcon = iconWrapper('fa-caret-up');

export const SummaryDownIcon = iconWrapper('fa-caret-down');

export const ArchiveIcon = iconWrapper('fa-file-zipper');

export const PrinterIcon = iconWrapper('fa-solid fa-print');

export const UploadIcon = iconWrapper('fa-solid fa-file-arrow-up');

export const GridIcon = iconWrapper('fa-solid fa-border-all');

export const SyncIcon = iconWrapper('fa-solid fa-arrows-rotate');

export const LoginIcon = iconWrapper('fa-right-to-bracket');

export const LogoutIcon = iconWrapper('fa-right-from-bracket');

export const BanIcon = iconWrapper('fa-ban');

export const InfoIcon = iconWrapper('fa-circle-info');

export const InfoOutlinedIcon = iconWrapper('fa-circle-info', 'regular');

export const HistoryIcon = iconWrapper('fa-clock-rotate-left');

export const SortIcon = iconWrapper('fa-sort');

export const CheckCircleIcon = iconWrapper('fa-circle-check');

export const CirclePlusIcon = iconWrapper('fa-circle-plus');

export const CircleMinusIcon = iconWrapper('fa-circle-minus');

export const DownloadIcon = iconWrapper('fa-download');

export const SmsIcon = iconWrapper('fa-comment-sms');

export const ExpandMoreIcon = iconWrapper('fa-chevron-down');

export const ExpandLessIcon = iconWrapper('fa-chevron-up');

export const SendIcon = iconWrapper('fa-paper-plane');

export const ExternalLinkIcon = iconWrapper('fa-arrow-up-right-from-square');

export const EmailQueuedIcon = iconWrapper('fa-clock', 'regular');

export const EmailDeliveredIcon = iconWrapper('fa-envelope', 'regular');

export const EmailErrorIcon = iconWrapper('fa-triangle-exclamation', 'regular');

export const LockIcon = iconWrapper('fa-lock');

export const LockOpenIcon = iconWrapper('fa-lock-open');

export const ExclamationIcon = iconWrapper('fa fa-exclamation-circle');

export const CommentIcon = iconWrapper('fa-comment');

export const CopyIcon = iconWrapper('fa-copy');

export const BuildingIcon = iconWrapper('fa-building', 'regular');

export const HotelIcon = iconWrapper('fa-hotel');

export const ShipIcon = iconWrapper('fa-ship');

export const TagsIcon = iconWrapper('fa-tags');

export const CircleXmarkIcon = iconWrapper('fa-circle-xmark', 'regular');

export const FileLinesIcon = iconWrapper('fa-file-lines', 'regular');

export const GlobeIcon = iconWrapper('fa-globe');

export const ShareNodesIcon = iconWrapper('fa-share-nodes');

export const FileInvoiceDollarIcon = iconWrapper('fa-file-invoice-dollar');

export const FileCheckIcon = iconWrapper('fa-file-circle-check');
